export default (({ colors }) => ({
  root: {
    marginTop: '32px',
  },
  textLine: {
    marginBottom: '8px',
    color: colors.black,
  },
}));
